var BODY_MIN_LENGTH = 150;
var BODY_MAX_LENGTH = 5000;
var TITLE_MIN_LENGTH = 30;
var TITLE_MAX_LENGTH = 120;
var ratingToLabel = function ratingToLabel(score) {
  var map = ['Malo', 'Mejorable', 'Regular', 'Bueno', 'Excelente'];
  return score > 0 ? map[score - 1] : '';
};
var featureToLabel = function featureToLabel(score) {
  var map = ['Malo', 'Mejorable', 'Bueno', 'Excelente'];
  return score > 0 ? map[score - 1] : 'Pulsa para puntuar';
};
var getBodyLength = function getBodyLength(body) {
  return body.length;
};
var isTitleValid = function isTitleValid(title) {
  return title.length >= TITLE_MIN_LENGTH && title.length <= TITLE_MAX_LENGTH;
};
var isBodyValid = function isBodyValid(body) {
  return getBodyLength(body) >= BODY_MIN_LENGTH && getBodyLength(body) <= BODY_MAX_LENGTH;
};
var validateFields = function validateFields(title, body, score, terms) {
  return isTitleValid(title) && isBodyValid(body) && score > 0 && terms;
};
var getSubmitTooltip = function getSubmitTooltip(title, body, score) {
  if (score === 0) {
    return 'Pulsa una estrella para valorar';
  }
  if (!isTitleValid(title)) {
    return 'Escribe un título válido';
  }
  if (!isBodyValid(body)) {
    return 'Escribe una opinión válida';
  }
  return null;
};
var getErrors = function getErrors() {
  var errors = [];
  return errors;
};
var getTitleHint = function getTitleHint(title) {
  var length = title.length;
  if (length === 0) {
    return "".concat(TITLE_MIN_LENGTH, " caracteres m\xEDnimo");
  }
  if (length >= TITLE_MIN_LENGTH && length <= TITLE_MAX_LENGTH) {
    return "Perfecto";
  }
  if (length > TITLE_MAX_LENGTH) {
    return "El t\xEDtulo debe tener una longitud m\xE1xima de ".concat(TITLE_MAX_LENGTH, " caracteres");
  }
  return "Te faltan ".concat(TITLE_MIN_LENGTH - length, " caracteres");
};
var getBodyHint = function getBodyHint(body) {
  if (getBodyLength(body) === 0) {
    return "".concat(BODY_MIN_LENGTH, " caracteres m\xEDnimo");
  }
  if (BODY_MIN_LENGTH > getBodyLength(body)) {
    return "Te faltan ".concat(BODY_MIN_LENGTH - getBodyLength(body), " caracteres");
  }
  if (getBodyLength(body) < BODY_MIN_LENGTH + 100) {
    return 'Perfecto';
  }
  return "Te faltan ".concat(BODY_MAX_LENGTH - getBodyLength(body), " caracteres para llegar a la longitud m\xE1xima");
};
export { BODY_MIN_LENGTH, BODY_MAX_LENGTH, TITLE_MIN_LENGTH, TITLE_MAX_LENGTH, ratingToLabel, featureToLabel, getBodyLength, isTitleValid, isBodyValid, validateFields, getSubmitTooltip, getErrors, getTitleHint, getBodyHint };